import {Component, Input, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";
import {LaboratoriosEmissoresService} from './laboratorios-emissores.service';
import {LaboratoriosEmissoresModel} from './laboratorios-emissores.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var swal, $: any;



@Component({
  selector: 'app-laboratorios-emissores',
  templateUrl: './laboratorios-emissores.component.html'
})
export class LaboratoriosEmissoresComponent extends Components implements OnInit {

  @Input()
  id_laboratorio: string = '';

  formEmissor: FormGroup;
  emissores: LaboratoriosEmissoresModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  emissor = {"id_emissor": null, "id_laboratorio": null, "nome": ""};
  enviandoForm = false;

  constructor(
    formBuilder: FormBuilder,
    private emissoresService: LaboratoriosEmissoresService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.formEmissor = formBuilder.group({
      id_emissor: [],
      id_laboratorio: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'laboratorios'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.getPage(1);
  }

  delete(emissor) {
    let emissores = this.emissores;
    let emissoresService = this.emissoresService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarEmissor')+emissor.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(emissores);
        }

        let index = emissores.indexOf(emissor);
        emissores.splice(index, 1);

        emissoresService.apagar(emissor.id_emissor)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.emissores = emissores;
            },
            err => {
              // Revert the view back to its original state
              emissores.splice(index, 0, emissor);
              self.emissores = emissores;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.emissoresService.getPaginacao(pagina,this.itensPorPagina, null, {"id_laboratorio": this.id_laboratorio})
      .subscribe(data => {
        this.emissores = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  modalAddEmissor(){
    $('#modalAddEmissor').modal('show');
  }

  addEmissor() {
    let result,
      values = this.emissor;

    values.id_laboratorio = this.id_laboratorio;

    this.enviandoForm = true;

    if (values.id_emissor) {
      result = this.emissoresService.editar(values, values.id_emissor);
    } else {
      result = this.emissoresService.adicionar(values);
    }

    result.subscribe(data => {
      this.emissor.nome = "";
      this.emissor.id_emissor = null;
      $('#modalAddEmissor').modal('hide');
      this.getPage(this.paginaAtual);
    },
      error => {
        let json = error.json();
        this.func.showErro(json);

        this.enviandoForm = false;

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.formEmissor.controls[i].setErrors(erro);
        }
      });
  }

  editarEmissor(emissor){
    this.emissor = emissor;
    $('#modalAddEmissor').modal('show');
  }
}



// WEBPACK FOOTER //
// ./src/app/laboratorios/laboratorios-emissores.component.ts